import { Form, Select } from 'antd';
import React from 'react';
import {CriterionHes} from "../../containers/HealthcareUsageReport/types/CohortQuery";
import {getCriterionValue} from "../../containers/CohortBuilder/criterion";

const { Option } = Select

const FIELD_NAME = "gender"
const FIELD_LABEL = "Gender"

interface Props {
    criterion?: CriterionHes
}

const GenderSelector = ({ criterion }: Props) => {

    return <Form.Item name={FIELD_NAME} label={FIELD_LABEL} initialValue={getCriterionValue(criterion, FIELD_NAME)} rules={[]}>
        <Select data-testid={'gender-selector'}
                allowClear={true}
                mode="multiple"
                style={{ width: '100%' }}
                placeholder={FIELD_LABEL}
                filterOption={true}
            >
                <Option value='female'>Female</Option>
                <Option value='male'>Male</Option>
            </Select>
    </Form.Item >
}

export default GenderSelector